"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGOUT_CHANNEL_NAME = exports.LOGOUT_CHANNEL_MESSAGE = exports.DEFAULT_BEARER_KEY_NAME = void 0;
const DEFAULT_BEARER_KEY_NAME = exports.DEFAULT_BEARER_KEY_NAME = "webauto_auth_js_bearer";
const LOGOUT_CHANNEL_MESSAGE = exports.LOGOUT_CHANNEL_MESSAGE = "WebAutoAuthSDK/single_sign_out";
const LOGOUT_CHANNEL_NAME = exports.LOGOUT_CHANNEL_NAME = "WebAutoAuthSDK/single_sign_out_channel";
//# sourceMappingURL=index.js.map